import { createFileRoute } from "@tanstack/react-router"
import { useFlags } from "~/features/feature-flags"
import NotFound from "~/components/reusable/NotFound"
import CustomerInsights from "~/pages/sales-operations/customer-insights"
import { usePageTracking } from "../../../hooks/usePageTracking"

export const Route = createFileRoute("/_auth/insights/customer-insights")({
  component: RouteComponent,
})

function RouteComponent() {
  const { customerInsightsPage: customerInsightsPageFlag } = useFlags()
  usePageTracking("Customer Insights")

  if (customerInsightsPageFlag === false) {
    return <NotFound />
  }

  return <CustomerInsights />
}
